import { Channel, ChannelEvents } from '@anycable/core';
import { gql } from 'graphql-request';

type WorkflowEventsInput = {
  workflowId: string;
};

type WorkflowEventsParams = {
  channel: 'GraphqlChannel';
  query: string;
  variables: string;
  operationName: 'workflowEventsUpdated';
};

const WORKFLOW_EVENTS_SUBSCRIPTION_QUERY = gql`
  subscription workflowEventsUpdated($workflowId: AiDuoWorkflowsWorkflowID!) {
    workflowEventsUpdated(workflowId: $workflowId) {
      checkpoint
      errors
      metadata
    }
  }
`;

export type WorkflowEventsType = {
  checkpoint: string;
  errors: string[];
  metadata: string;
};

type WorkflowEventsResponseType = {
  result: {
    data: {
      workflowEventsUpdated: WorkflowEventsType;
    };
  };
  more: boolean;
};

interface WorkflowEventsChannelEvents extends ChannelEvents<WorkflowEventsResponseType> {
  checkpoint: (msg: WorkflowEventsType) => void;
}

export class WorkflowEventsChannel extends Channel<
  WorkflowEventsParams,
  WorkflowEventsResponseType,
  WorkflowEventsChannelEvents
> {
  static identifier = 'GraphqlChannel';

  constructor(params: WorkflowEventsInput) {
    super({
      channel: 'GraphqlChannel',
      query: WORKFLOW_EVENTS_SUBSCRIPTION_QUERY,
      variables: JSON.stringify(params),
      operationName: 'workflowEventsUpdated',
    });
  }

  receive(message: WorkflowEventsResponseType) {
    if (!message.result.data.workflowEventsUpdated) return;

    const data = message.result.data.workflowEventsUpdated;

    this.emit('checkpoint', data);
  }
}
